import React, { Component } from "react";
import { connect } from 'react-redux'
// Components
import Table from "../../../../../components/Table";
import Container from "../../../../../containers/Container";
import { Row, Col, Modal, Icon, Tooltip } from "antd";
import Button from "../../../../../components/Buttons";
import message from "../../../../../components/Messages";
import Message from "../../../../../components/Messages";
// typo
import typo, { MESSAGE } from "../../../../../constants/dictionaries";
import columns from "./VTQT.column";
import InfoTramQT from "../../../../../components/License/BieuDo/mauQTModal"
import TramQTModal from "./Modal"
import Api_tnn from "../../../../../api/api.tnn";
import QT_TramQT from "../../../../../models/QuanTrac_TNN/QT_TramQT";
class TramQT_TNN extends Component {
    constructor(props) {
        super(props);
        const { functions } = props;
        this.state = {
            data: [],
            mode: "add",
            pagination: {
                PageNumber: 1,
                PageSize: 10,
                Total: 0
            },

            selectedRow: null,
            isShowEditModal: false,
            isShowAddModal: false,
            isShowMapModal: false,
            LoaiTram_QT: undefined,
            selectedItemId: undefined,
        };
    }

    componentDidMount() {
        const { idGiayPhep } = this.props;
        const { pagination } = this.state
        idGiayPhep && this.getGiayPhepCTById(pagination.PageNumber, pagination.PageSize)
    }
    getGiayPhepCTById = (page, size) => {
        const { idGiayPhep } = this.props;
        new Api_tnn().GetTNN_BCDK_TramQuanTracs_ByGiayPhep({ token: this.props.user.access_token, IdGiayPhep: idGiayPhep, page: page, size: size })
            .then(res => {
                this.setState({
                    data: res && res.data.map((vl, index) => ({ ...new QT_TramQT(vl), stt: index + 1 })),
                    pagination: {
                        PageNumber: res && res.pagination && res.pagination.currentPage,
                        PageSize: size,
                        Total: res && res.pagination && res.pagination.total
                    },

                })
            })
            .catch(err => {
                Message.error(err.message)
            })
    };
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { pagination } = this.state
        if (prevProps.idGiayPhep !== this.props.idGiayPhep) {
            this.getGiayPhepCTById(pagination.PageNumber, pagination.PageSize)
        }
    }
    GetApiQT_TramQuanTrac = (id) => {
        return new Api_tnn()
            .GetTNN_BCDK_TramQuanTrac({
                token: this.props.user.access_token,
                id: id,
            })
            .then((res) => {
                this.setState({
                    isShowEditModal: true,
                    selectedItemId: undefined,
                    selectedRow: new QT_TramQT(res),
                });
            }).catch(err => {
                message.error(err.message)
            });
    };

    DeleteApiQT_TramQuanTrac = (id) => {
        const { pagination } = this.state
        new Api_tnn()
            .DeleteTNN_BCDK_TramQuanTrac({
                token: this.props.user.access_token,
                id: id,
            })
            .then(res => {
                this.setState({
                    selectedItemId: undefined,
                });
                message.success(MESSAGE.CSCORE_REMOVE_SUCCESS)
                this.getGiayPhepCTById(pagination.PageNumber, pagination.PageSize)
            }).catch(err => {
                message.error(err.message)
            });
    };
    expandedRow = (record, index, indent, expanded) => {
        const { user, editable } = this.props
        let data_modal_mau = {
            idGiayPhep: record.idGiayPhep,
            idTramQT: record.id
        }
        return <InfoTramQT user={user} data_modal_mau={data_modal_mau} editable={editable}/>
    }
    showEditModal = (selectedRow, name) => {
        this.setState({ mode: name })
        this.GetApiQT_TramQuanTrac(selectedRow.id)
    };
    showAddModal = () => {
        this.setState({
            isShowAddModal: true,
            selectedItemId: undefined,
        });
    };
   
    showMapModal = async (selectedRow) => {
        const { handleMap } = this.props;
        if(selectedRow.toaDo){
            handleMap(selectedRow)
        }
        else{
            message.warning("Không có tọa độ")
        }
     
    }
    handleAdd = () => {
        const { pagination } = this.state
        this.getGiayPhepCTById(pagination.PageNumber, pagination.PageSize)
        this.handleCancel();
    };

    handleCancel = () => {
        this.setState({
            isShowEditModal: false,
            isShowAddModal: false,
            isShowMapModal: false,
        });
    };

    showDeleteConfirm = (selectedRow) => {
        this.setState({
            selectedRow
        });
        this.DeleteApiQT_TramQuanTrac(selectedRow)
    }
    /**
     * @function handleTableParamsChange Handle table params
     */
    handleTableParamsChange = (pagination, filteredInfo, sortedInfo) => {
        this.getGiayPhepCTById(pagination.current, pagination.pageSize)
    };


    render() {
        const {
            sortedInfo,
            selectedRow,
            isShowEditModal,
            isShowAddModal,
            isShowMapModal,
            pagination,
            data,
            selectedItemId,
            mode
        } = this.state;
        const { user, data_giayphep, editable } = this.props;
        return (
            <div>
                <Container>
                    {editable &&
                    <Row type='flex' justify='end' style={{ marginBottom: 10}}>
                        <Tooltip title="Thêm mới" placement="top">
                            <Button type="primary" onClick={this.showAddModal}>
                                <Icon type="plus" />
                            </Button>
                        </Tooltip>
                    </Row>}
                    {data.length > 0 ?
                        <Table
                            columns={columns({
                                sortedInfo,
                                showEditModal: this.showEditModal,
                                deleteRow: this.showDeleteConfirm,
                                showMapModal: this.showMapModal,
                                showViewModal: this.showEditModal,
                                editable
                            })}
                            selectedRowId={selectedItemId}
                            onRowClick={(record) => this.setState({ selectedItemId: record.id })}
                            dataSource={data}
                            hideTotal="true"
                            onChange={this.handleTableParamsChange}
                            pagination={{
                                total: pagination.Total,
                                pageSize: pagination.PageSize,
                                current: pagination.PageNumber
                            }}
                            expandedRowRender={this.expandedRow}
                        /> : <div style={{ color: "#cfcdcd", textAlign: "center" }}>Không có vị trí quan trắc</div>}
                    {isShowEditModal &&
                        <Modal
                            title={mode === "view" ? typo.cscore_thong_tin_chi_tiet : typo.cscore_edit_tramQT}
                            centered
                            closable={true}
                            visible={isShowEditModal}
                            width="900px"
                            footer={null}
                            onCancel={this.handleCancel}
                            maskClosable={false}
                        >
                            <TramQTModal
                                handleAdd={this.handleAdd}
                                handleCloseModal={this.handleCancel}
                                defaultData={data}
                                selectedRow={selectedRow}
                                isEdit={true}
                                user={user}
                                mode={mode}
                            />
                        </Modal>
                    }
                    {isShowAddModal &&
                        <Modal
                            title={typo.cscore_add_tramQT}
                            centered
                            closable={true}
                            visible={isShowAddModal}
                            width="900px"
                            footer={null}
                            onCancel={this.handleCancel}
                            maskClosable={false}
                        >
                            <TramQTModal
                                handleAdd={this.handleAdd}
                                handleCloseModal={this.handleCancel}
                                user={user}
                                selectedRow={data_giayphep}
                            />
                        </Modal>
                    }
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.oidc.user,
    functions: state.functions
});

export default connect(mapStateToProps)(TramQT_TNN);
